export function resolvedScheduleBotType(settingsBotType, cookieBotType) {
  if (typeof settingsBotType === "string" && settingsBotType !== "") {
    return settingsBotType;
  }
  if (typeof cookieBotType === "string" && cookieBotType !== "") {
    return cookieBotType;
  }
  return "real_estate_v1";
}

export function roofingV2ScheduleSaveAllowed(botType) {
  return botType !== "roofing_v2";
}
